import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

const copy = {
  cs: {
    before: "Jsem podnikatel a souhlasím s ",
    terms: "obchodními podmínkami",
    middle: ". Beru na vědomí ",
    privacy: "zásady ochrany osobních údajů",
    after: ".",
  },
  en: {
    before: "I am a business and I agree to the ",
    terms: "terms of service",
    middle: ". I have read the ",
    privacy: "privacy policy",
    after: ".",
  },
};

const linkClass =
  "text-foreground underline underline-offset-2 hover:text-[hsl(var(--action))] dark:hover:text-primary";

/**
 * The required terms acceptance with the B2B declaration (#63): on the
 * register tab, before Google / Microsoft sign-up, and in the terms gate for
 * accounts created through them.
 */
export function TermsCheckbox({
  id,
  language,
  checked,
  onCheckedChange,
  error,
}: {
  id: string;
  language: "cs" | "en";
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  error?: string;
}) {
  const t = copy[language];
  return (
    <div className="space-y-2">
      <div className="flex items-start gap-3">
        <Checkbox
          id={id}
          checked={checked}
          onCheckedChange={(value) => onCheckedChange(value === true)}
          aria-invalid={error ? true : undefined}
          className="mt-0.5"
        />
        <Label htmlFor={id} className="text-sm font-normal leading-snug text-muted-foreground">
          {t.before}
          <a
            href={`/${language}/terms`}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClass}
          >
            {t.terms}
          </a>
          {t.middle}
          <a
            href={`/${language}/privacy`}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClass}
          >
            {t.privacy}
          </a>
          {t.after}
        </Label>
      </div>
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
}
